import { portalRoles } from '../enums/portalRoles';

export const isProfileEmployee = profile => profile.role === portalRoles.EMPLOYEE;
